import * as yup from "yup"
import _get from "lodash/get"
import _size from "lodash/size"
import _filter from "lodash/filter"
import _find from "lodash/find"
import _includes from "lodash/includes"
import _map from "lodash/map"
import _sumBy from "lodash/sumBy"
import _toUpper from "lodash/toUpper"
import _some from "lodash/some"
import _toLower from "lodash/toLower"

import { userType } from "./constants"
import { maskCNPJ, maskTel } from "services/utils/mask"
import { validatePhone } from "services/utils/phoneValidation"
import { BLACKLIST } from "services/state/billing/constants"

export const validateEmail = (email) => {
  if (!email) {
    return false
  }

  const emailGenericWords = [
    "test",
    "teste",
    "testing",
    "testando",
    "example",
    "exemplo",
    "temp",
    "user",
    "demo",
    "email"
  ]

  const normalizedEmail = email.toLowerCase().trim()
  const [localPart, domainPart] = normalizedEmail.split("@")

  if (!localPart || !domainPart) {
    return false
  }

  const domainName = domainPart.split(".")[0]

  const isGenericLocal = emailGenericWords.includes(localPart)
  const isGenericDomain = emailGenericWords.includes(domainName)

  return !(isGenericLocal || isGenericDomain)
}

export const calculateSizeFile = (file) =>
  (file.size / (1024 * 1024)).toFixed(2)

export const removeSpecialCharacters = (str) =>
  str ? str.replace(/[`~!@#$%^&*() _|+\-=?;:'",.<>{}[\]\\/]/gi, "") : ""

const validationSizeFile = (value) => {
  if (value) {
    const totalSize = _sumBy(value, "file.size")
    const totalSizeInMB = calculateSizeFile({ size: totalSize })

    return totalSizeInMB < 1
  }

  return true
}
export const ValidateSchema = yup.object().shape({
  cnpj: yup.string().required("Campo obrigatório"),
  username: yup.string().required("Campo obrigatório"),
  message: yup.string().required("Campo obrigatório"),
  phone: yup
    .string()
    .required("Campo obrigatório")
    .test("isValidPhone", "Número de telefone inválido", (value) => {
      if (!value) {
        return false
      }

      const phone = removeSpecialCharacters(value)
      const sizePhone = _size(phone)
      const validPhone = validatePhone(phone)

      return (
        (sizePhone === 10 || sizePhone === 11 || sizePhone === 12) && validPhone
      )
    }),
  email: yup
    .string()
    .email("Email inválido")
    .required("Campo obrigatório")
    .test("isValidEmail", "Email inválido", (value) => validateEmail(value)),
  product: yup.string().required("Campo obrigatório"),
  reason: yup.string().required("Campo obrigatório"),
  requester: yup.string().required("Campo obrigatório"),
  officeHours: yup.string().required("Campo obrigatório"),
  accessAuthorized: yup.string().required("Campo obrigatório"),
  evidenceFile: yup
    .mixed()
    .test(
      "evidenceFile",
      "Os arquivos não podem ser maiores que 1MB",
      validationSizeFile
    )
})

export const ValidateSchemaComments = yup.object().shape({
  file: yup
    .mixed()
    .test(
      "evidenceFile",
      "Os arquivos não podem ser maiores que 5MB",
      validationSizeFile
    )
})

function orderCharacteristic({
  email,
  flag = "1",
  reason = "Interrompido",
  name,
  phoneNumber,
  openField
}) {
  const orderArray = [
    {
      code: "IMPACT",
      type: "field",
      value: reason,
      status: "SERVICE_ORDER"
    },
    {
      code: "PRIORITY",
      type: "field",
      value: "Alta",
      status: "SERVICE_ORDER"
    },
    {
      code: "ACCEPT_EMAIL_CONTACT",
      type: "field",
      value: email,
      status: "SERVICE_ORDER"
    },
    {
      code: "FLAG_AUTHORIZED_ACCESS",
      type: "field",
      value: flag,
      status: "SERVICE_ORDER"
    },
    {
      code: "FLAG_FIRST_CALL_RESOLUTION",
      type: "field",
      value: "0",
      status: "SERVICE_ORDER"
    },
    {
      code: "ALTERNATIVE_NAME_CONTACT",
      type: "field",
      value: name,
      status: "SERVICE_ORDER"
    },

    {
      code: "ALTERNATIVE_PHONE_CONTACT",
      type: "field",
      value: phoneNumber,
      status: "SERVICE_ORDER"
    },

    {
      code: "ALTERNATIVE_EMAIL_CONTACT",
      type: "field",
      value: email,
      status: "SERVICE_ORDER"
    }
  ]

  if (openField) {
    orderArray.push({
      code: "VISAO_SMARTSCRIPT_SCHEDULING",
      type: "field",
      value: "1",
      status: "SERVICE_ORDER"
    })
  }

  return orderArray
}

function orderCharacteristicFRC({
  email,
  flag = "1",
  reason = "Interrompido",
  name,
  phoneNumber,
  openField
}) {
  const orderArray = [
    {
      code: "IMPACT",
      type: "field",
      value: reason,
      status: "SERVICE_ORDER"
    },
    {
      code: "PRIORITY",
      type: "field",

      value: "Alta",
      status: "SERVICE_ORDER"
    },
    {
      code: "ACCEPT_EMAIL_CONTACT",
      type: "field",
      value: email,
      status: "SERVICE_ORDER"
    },
    {
      code: "FLAG_AUTHORIZED_ACCESS",
      type: "field",
      value: flag,
      status: "SERVICE_ORDER"
    },
    {
      code: "FLAG_FIRST_CALL_RESOLUTION",
      type: "field",
      value: "1",
      status: "SERVICE_ORDER"
    },
    {
      code: "INCIDENT_CODE_AREA",
      type: "field",
      value: "A",
      status: "SERVICE_ORDER"
    },
    {
      code: "INCIDENT_NAME_AREA",
      type: "field",
      value: "CLIENTE",
      status: "SERVICE_ORDER"
    },
    {
      code: "INCIDENT_CODE_GROUP",
      type: "field",
      value: "A1",
      status: "SERVICE_ORDER"
    },
    {
      code: "INCIDENT_NAME_GROUP",
      type: "field",
      value: "CLIENTE",
      status: "SERVICE_ORDER"
    },
    {
      code: "INCIDENT_CODE_CAUSE",
      type: "field",
      value: "A10",
      status: "SERVICE_ORDER"
    },
    {
      code: "INCIDENT_NAME_CAUSE",
      type: "field",
      value: "DEFEITO NO AMBIENTE DO CLIENTE",
      status: "SERVICE_ORDER"
    },
    {
      code: "ALTERNATIVE_NAME_CONTACT",
      type: "field",
      value: name,
      status: "SERVICE_ORDER"
    },

    {
      code: "ALTERNATIVE_PHONE_CONTACT",
      type: "field",
      value: phoneNumber,
      status: "SERVICE_ORDER"
    },

    {
      code: "ALTERNATIVE_EMAIL_CONTACT",
      type: "field",
      value: email,
      status: "SERVICE_ORDER"
    }
  ]

  if (openField) {
    orderArray.push({
      code: "VISAO_SMARTSCRIPT_SCHEDULING",
      type: "field",
      value: "1",
      status: "SERVICE_ORDER"
    })
  }

  return orderArray
}

export function formatPayloadIncident({
  requestType,
  assetDetails,
  customer,
  idInteraction,
  protocol,
  valuesUser,
  FCR,
  openField = false,
  notes = ""
}) {
  const values = {
    area: "CRIAR",
    requestType,
    reason: "SOLICITACAO",
    reason2: "PRODUTOS/SERVICOS",
    reason3: requestType,
    user: userType,
    origination: userType,
    contractNumber: assetDetails.assetId,
    systemProduct: assetDetails.crmSystem,
    businessLine: assetDetails.lineOfBusiness,
    product: assetDetails.productId,
    productName: assetDetails.productName,
    serviceId: assetDetails.serviceId,
    customerId: customer.data.customerId,
    documentNumber: valuesUser.cnpj
      ? valuesUser.cnpj.replace(/\D/g, "")
      : customer.data.documentNumber,
    legalName: customer.data.name,
    phoneNumber: valuesUser.phone,
    contactphone: valuesUser.phone,
    contactName: customer.data.name,
    protocol,
    idInteracao: idInteraction,
    description: FCR
      ? `Abertura de ${requestType} - COM FCR - ${valuesUser.reason}`
      : `Abertura de ${requestType} - ${valuesUser.reason}`,
    Contract: {
      type: "COMUNICACAO DADOS",
      status: assetDetails.status
    },
    OrderCharacteristic: FCR
      ? orderCharacteristicFRC({
          email: valuesUser.email,
          flag: valuesUser.accessAuthorized || "1",
          reason: valuesUser.reason,
          name: valuesUser.requester,
          phoneNumber: valuesUser.phone,
          openField
        })
      : orderCharacteristic({
          email: valuesUser.email,
          flag: valuesUser.accessAuthorized || "1",
          reason: valuesUser.reason,
          name: valuesUser.requester,
          phoneNumber: valuesUser.phone,
          openField
        }),
    notes
  }
  return values
}

export function getAddress(details) {
  const assetDetails = _get(details, "assetDetails", null)
  const address = _get(assetDetails, "[0].address", null)
  const addressInstall = _filter(address, (item) => item.type === "INSTALACAO")
  const finalAddress = _get(addressInstall, "[0].street", null)
  return finalAddress
    ? `${finalAddress.typeCode} ${finalAddress.name},  ${finalAddress.addressNumber} - ${finalAddress.neighbourhood.name}`
    : ""
}

export function getStatus(details, id) {
  const assetDetails = _get(details, "assetDetails", null)
  const detail = _find(assetDetails, { serviceId: id })
  const status = _get(detail, "status", null)
  return status
}

function getHostName({ myCalls }) {
  const inventoryData = _get(myCalls, "inventoryData.dadosRede", null)
  const incInterface = _get(inventoryData, "incInterface", null)

  if (!incInterface) return null

  return _filter(
    incInterface,
    (item) =>
      _includes(item.equipment, "c-bl-rt") ||
      _includes(item.equipment, "a-bb-rt")
  )
}

export function formatHostname({ myCalls }) {
  const equipament = getHostName({ myCalls })
  return _get(equipament, "[0].equipment", null)
}

export function formatTNCM2({ productSelected, myCalls }) {
  const equipament = getHostName({ myCalls })
  const sourceIp = _get(equipament, "[0].ip", null)
  const interfaceName = _get(equipament, "[0].ifName", null)

  const cpeDiscovery = _get(
    myCalls,
    "inventoryData.dadosRede.cpeDiscovery.[0].interfaceIp",
    null
  )

  let vrf = " "

  if (productSelected === "Voz Total") {
    vrf = "VPN-13"
  }

  if (productSelected === "Clear Channel") {
    vrf = "VPN-20"
  }

  return {
    deviceId: _get(myCalls, "device", null),
    targetIp: cpeDiscovery,
    sourceIp,
    interface: interfaceName,
    vrf
  }
}

export function formatPayloadInteraction({ customer, myCalls, values }) {
  return {
    documentNumber: values.cnpj
      ? values.cnpj.replace(/\D/g, "")
      : customer.data.documentNumber,
    protocol: myCalls.protocol,
    description: "Abertura de Incidente Portal",
    contact: {
      name: customer.data.name,
      phoneNumber: values.phone,
      email: values.email
    },
    notification: {
      method: "EMAIL",
      contact: values.email
    },
    requestChannel: "PORTAL",
    user: "PORTAL",
    note: "Abertura de Incidente Portal"
  }
}

export function formatPayloadSOM({ productName, orderId, notes }) {
  return {
    orderId,
    notes,
    productName,
    businessUnit: "Dados",
    systemOrder: "SOM",
    createdBy: userType
  }
}

export const validateProducts = (products) => {
  const productsValid = products.isMpe
    ? products.productsValidMpe
    : products.productsTNCM

  return _filter(productsValid, (item) => {
    const productName = _toUpper(item.product.name)
    const isBlocked = _includes(item.tarja, "Bloqueio", "")

    return (
      item.status !== "CANCELADO" &&
      !isBlocked &&
      !includesLike(productName, BLACKLIST)
    )
  })
}

export function formatProducts(products) {
  const options = validateProducts(products)
  return _map(options, (item) => {
    const productName = _get(item, "assetFullName", "")

    return {
      value: item.assetTag,
      label: `${item.assetTag} - ${productName}`
    }
  })
}

export function formatPhone(phone) {
  if (!phone) return ""
  if (phone && phone[0] === "0") phone = phone.replace("0", "")
  return maskTel(phone)
}

export function formatValues(values) {
  return {
    circuit: "",
    product: "",
    address: "",
    reason: "",
    phone: "",
    originalPhone: values.agentPhone,
    email: "",
    message: "",
    cnpj: maskCNPJ(values.documentNumber) || maskCNPJ(values.cnpj),
    username: values.username || values.name,
    requester: "",
    officeHours: "",
    accessAuthorized: "",
    evidenceFile: "",
    productName: ""
  }
}

export function formatPayloadUnblocking({ assetNumber }) {
  return {
    assetNumber,
    message: "DESBLOQUEIO EM CONFIANÇA",
    user: userType
  }
}

export function formatPayloadVerifyCalled({ cpfCnpj, circuitId }) {
  return {
    cpfCnpj,
    circuitId
  }
}

export function formatPayloadInitialTest({ idTecnologia, circuitId }) {
  return {
    idTecnologia,
    ipPe: "",
    ipSw: "",
    idCircuito: circuitId
  }
}

export function formatPreSchedule({
  serviceOrderSomId,
  schedulingDate,
  timeSlot
}) {
  return {
    hasScheduling: true,
    flagHasReturn: 0,
    actionLov: "721",
    teamLov: "Mantenedora_Dados",
    externalLocRegulatoryCode: "32549B",
    serviceOrderSomId,
    schedulingDate,
    timeSlot,
    user: "schedprt_integration"
  }
}

export function formatPayloadWorklogs({
  email,
  name,
  phoneNumber,
  documentNumber
}) {
  const payload = {
    origin: {
      type: "Voce"
    },
    contactEmail: email,
    contactPhoneNumber: phoneNumber,
    contactName: name,
    leadType: {
      id: "3"
    },
    customer: {
      primaryDocumentNumber: documentNumber,
      email,
      name
    },
    originIntegrationId: "Guest Checkout",
    originIntegrationType: "PORTAL DE VENDAS"
  }

  return payload
}

export const normalizeProductName = (name) => {
  const normalize = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[-/]/g, " ")
  return normalize.toUpperCase()
}

export function mapIdTecnologia(tecnologia) {
  const businessLineMap = {
    "INTERNET LINK": "1",
    "VPN MPLS": "2",
    "VPN NODE": "2",
    "IP TRANSITO": "3",
    "VOZ TOTAL": "4",
    "LAN TO LAN": "5",
    "LAN TO LAN NODE": "5"
  }
  const normalizedTecnologia = normalizeProductName(tecnologia)

  for (const key in businessLineMap) {
    if (normalizedTecnologia === key) {
      return businessLineMap[key]
    }
  }

  return null
}

export const formatFiles = (files) => {
  return _map(files, (file) => ({
    file,
    progress: 0,
    sucess: null
  }))
}

export const includesLike = (productName, arrayProduct) =>
  _some(arrayProduct, (item) =>
    _includes(_toLower(productName), _toLower(item))
  )

export const isCloudPhone = (productName) =>
  _toUpper(productName).includes("CLOUD PHONE")

export const getSubsidiaryOptions = (customerData) => {
  const subsidiaries = _get(customerData, "subsidiaryList", [])

  const mainCNPJ = customerData.documentNumber || customerData.cnpj

  const options = _map(subsidiaries, (sub) => {
    const cnpjValue = sub.cnpj || sub.documentNumber
    return {
      label: maskCNPJ(cnpjValue),
      value: maskCNPJ(cnpjValue)
    }
  })

  const mainExists = _some(
    subsidiaries,
    (sub) => (sub.cnpj || sub.documentNumber) === mainCNPJ
  )

  if (mainCNPJ && !mainExists) {
    options.unshift({
      label: maskCNPJ(mainCNPJ),
      value: maskCNPJ(mainCNPJ)
    })
  }

  return options
}



// WEBPACK FOOTER //
// ./src/scenes/AddTicket/utils.js